import React from 'react';
import { Flex } from '@instructure/ui';
import JourneySteps from './Steps';
import { Card } from '@smarterservices/smarter-ui';
import Routing from './Routing';
import RoomFlow from './RoomFlow';
import './styles.css';
const Journey = () => {
  return (
    <Flex
      as="div"
      direction="row"
      height="100%"
      width="100%"
      alignItems="start"
    >
      <Flex.Item as="div" justifyItems="center" width="640px">
        <Card>
          <Card.Header background="brand">
            <Card.Title>Session Journey</Card.Title>
          </Card.Header>
          <Card.Body>
            <JourneySteps />
          </Card.Body>
        </Card>
      </Flex.Item>
      <Flex.Item margin="none none none small" shouldGrow>
        <Card>
          <Card.Header background="brand">
            <Card.Title>Room Routing</Card.Title>
          </Card.Header>
          <Card.Body>
            <Routing />
          </Card.Body>
        </Card>
        <Card margin="small none none none">
          <Card.Header background="brand">
            <Card.Title>Room Flow</Card.Title>
          </Card.Header>
          <Card.Body>
            <RoomFlow />
          </Card.Body>
        </Card>
      </Flex.Item>
    </Flex>
  );
};

export default Journey;
